import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSignsActive from "./_components/BoxSignsActive";

const SignsActive = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSignsActive />
    </ContentWrapper>
  </>
);

export default SignsActive;
